export default "__VITE_ASSET__0e52be03__"